import React from 'react';

interface ReportSectionTitleProps {
    children: React.ReactNode;
    aside?: React.ReactNode;
}

const ReportSectionTitle: React.FC<ReportSectionTitleProps> = ({ children, aside }) => {
    return (
        <div className="management-overview-section-bar">
            <h2 className="management-overview-section-bar__title">{children}</h2>
            {aside ? <div className="management-overview-section-bar__aside">{aside}</div> : null}
        </div>
    );
};

export default ReportSectionTitle;
